export default __webpack_public_path__ + "images/md-orders.svg";